"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
var deepCopy = function (toCopy) {
    try {
        return JSON.parse(JSON.stringify(toCopy));
    }
    catch (err) {
        throw new Error("error while deep copying object: ".concat(err.message));
    }
};
exports.deepCopy = deepCopy;
